import {
    StyledCard,
    StyledCardInfo,
    StyledCardTitle,
    StyledDate,
    StyledImage,
    StyledLink
} from './Card.styled'

interface ICardProps {
    id: number
    type: string
    img: string | JSX.Element
    sectionName?: string
    date: string
    title: string
}

export const Card = ({
    id,
    type,
    img,
    sectionName,
    date,
    title
}: ICardProps) => {
    const isImageUrl = typeof img === 'string'

    return (
        <StyledCard>
            <StyledLink
                to={`/how-to/${type}/${id}`}
                state={{ sectionName, title }}
            />
            <StyledImage style={isImageUrl ? { backgroundImage: `url(${img})` } : undefined}>
                {!isImageUrl && img}
                <StyledDate>{date}</StyledDate>
            </StyledImage>
            <StyledCardInfo>
                <StyledCardTitle>{title}</StyledCardTitle>
            </StyledCardInfo>
        </StyledCard>
    )
}
